/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Javascript event handlers for manage reviews

namespace('Slzr.Page.ManageReviews', (exports, top) => Slzr.jQuery(function($) {
  if (Slzr.Meta.page !== 'manage-reviews') { return; }

  // Update rating input when clicking one of the submit buttons
  //
  // Do this here, because on mobile devices there isn't necessarily an "active" element
  $(document.body).on('click.manage-reviews', 'form[data-review="form"] input[data-rating-value]', function(evt) {
    const $this = $(this);
    $this.closest('form[data-review="form"]').find('input[name="rating"]').val($this.data('rating-value'));

    return true;
  });

  return $(document.body).on('submit.manage-reviews', 'form[data-review="form"]', function(evt) {
    const $form = $(this);

    // Update rating, only if activeElement is an INPUT tag
    //
    // This is meant for non-click interactions, but also handles clicks.
    if ($(document.activeElement).is("input[data-rating-value]")) {
      $form.find('input[name="rating"]').val($(document.activeElement).data('rating-value'));
    }

    // Validate review
    if ($form.find('[name="review"]').val().isBlank()) {
      alert('You must provide a review!');
      evt.preventDefault();
      return false;
    }
  });
}));
